export function toPersianNumberNotTag(str) {
  const arrayNumberItem = str.split("");
  const persianNumber = arrayNumberItem.map((item) => {
    if (item !== "h" || item !== "H") {
      return item
        .replace("0", "۰")
        .replace("1", "۱")
        .replace("2", "۲")
        .replace("3", "۳")
        .replace("4", "۴")
        .replace("5", "۵")
        .replace("6", "۶")
        .replace("7", "۷")
        .replace("8", "۸")
        .replace("9", "۹");
    } else {
      return item;
    }
  });
  return persianNumber.join("");
}
//old code => bug in tah h1 h2 ...

export function toPersianNumber(str) {
  const persianNumber = str.replace(/>([^<]*[0-9]+[^<]*)</g, (match) =>
    match.replace(/[0-9]/g, (digit) =>
      String.fromCharCode(digit.charCodeAt(0) + 1728)
    )
  );
  return persianNumber;
}

//new code
